import React, { useEffect, useState } from 'react'
import { Button, Form, Select, Spin, Modal, ConfigProvider } from 'antd'
import { addSite, fetchSiteListFromSite } from '../../apis/group'
import { FormButton } from './group.styled'
import { useTranslation } from 'react-i18next'

const SiteForm = props => {
  const [form] = Form.useForm()
  const { t: ln_t } = useTranslation()

  const { formMode, setFormMode, handleFetchParams, groupRecord } = props

  const [modalLoading, setModalLoading] = useState(false)
  const [siteList, setSiteList] = useState([])
  const [selectedSite, setSelectedSite] = useState({})

  const getSiteList = async () => {
    setModalLoading(true)

    const result = await fetchSiteListFromSite({ maxResults: 1000 })
    if (result.status === 200) {
      const siteOptions = result.data.map(data => ({ label: data.name, value: data.id }))
      setSiteList(siteOptions)
      // return siteOptions
    }
    setModalLoading(false)
  }

  const onSiteChange = value => {
    const site = siteList.find(item => item.value === value)
    setSelectedSite(site)
  }

  const handleCancel = () => {
    form.resetFields()
    setFormMode(false)
  }

  const onFinish = async fieldsValue => {
    const f = fieldsValue
    setModalLoading(true)

    const values = {
      siteId: f.siteId,
      siteName: selectedSite.label,
      groupId: groupRecord.id,
      status: 1
    }

    const result = await addSite(values)
    if (result?.status === 201) {
      handleFetchParams('add', {})
      handleCancel()
    }
    setModalLoading(false)
  }

  useEffect(() => {
    if (formMode) getSiteList()
  }, [formMode])

  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
        <Modal
          width="470px"
          open={formMode}
          title={ln_t('site.addNew')}
          footer={null}
          onCancel={handleCancel}
        >
        <Spin spinning={modalLoading}>
          <div className="main-form-container" style={{ marginTop: '15px' }}>
            <Form
              form={form}
              onFinish={onFinish}
              requiredMark={false}
              validateTrigger="onSubmit"
              layout="vertical"
            >
            <Form.Item label={ln_t('site.selectSite')} name="siteId" rules={[{ required: true, message: ln_t('site.pleaseSelectSite') }]}>
              <Select
                showSearch
                optionFilterProp="label"
                placeholder={ln_t('site.pleaseSelectSite')}
                options={siteList}
                onChange={value => onSiteChange(value)}
              />
            </Form.Item>
              <FormButton>
                <Button type="button" onClick={handleCancel} className="mr-2">{ln_t('util.cancel')}</Button>
                <Button type="primary" htmlType="submit">{ln_t('util.confirm')}</Button>
              </FormButton>
            </Form>
          </div>
        </Spin>
        </Modal>
        </ConfigProvider>
  )
}

export default SiteForm
